const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const mobileRegex = /^[0-9]{10}$/;

export function formValidation(values) {
  const errors = {};

  // Full Name
  if (!values.fullName || !values.fullName.trim()) {
    errors.fullName = "Full Name is required";
  } else if (values.fullName.trim().length < 3) {
    errors.fullName = "Full Name must be at least 3 characters";
  }

  // Email
  if (!values.email || !values.email.trim()) {
    errors.email = "Email is required";
  } else if (!emailRegex.test(values.email)) {
    errors.email = "Enter a valid email";
  }

  // Gender
  if (!values.gender) {
    errors.gender = "Gender is required";
  }

  // Mobile
  if (!values.mobile || !values.mobile.trim()) {
    errors.mobile = "Mobile number is required";
  } else if (!mobileRegex.test(values.mobile)) {
    errors.mobile = "Enter a valid 10-digit mobile number";
  }

  // Registration
  if (!values.registration || !values.registration.trim()) {
    errors.registration = "Registration number is required";
  } else if (values.registration.trim().length < 3) {
    errors.registration = "Registration number must be at least 3 characters";
  }

  // Programme
  if (!values.programme || !values.programme.trim()) {
    errors.programme = "Programme is required";
  } else if (values.programme.trim().length < 3) {
    errors.programme = "Programme must be at least 3 characters";
  }

  // Category
  if (!values.category || !values.category.trim()) {
    errors.category = "Grievance category is required";
  }

  // Message
  if (!values.message || !values.message.trim()) {
    errors.message = "Please enter your message";
  } else if (values.message.trim().length < 3) {
    errors.message = "Message must be at least 3 characters";
  }

  return errors;
}
